export default {
  defaultCloseTitle: "Discard Changes",
  defaultCloseMessage: "You have unsaved changes. Are you sure you want to discard them?",
  movePlanTitle: "Move Plan to Another Business Goal?",
  movePlanMessage: (scenarioCount: number): string =>
    `The generated output of ${scenarioCount} ${
      scenarioCount === 1 ? "scenario" : "scenarios"
    } in this plan will be marked as outdated and will need to be regenerated. Are you sure you want to continue?`,
  scenarioDeleteTitle: "Delete Scenario?",
  scenarioDeleteMessage: "This action cannot be undone, all data will be lost. Are you sure you want to continue?",
  templateDeleteTitle: "Delete Template?",
  templateDeleteMessage: "This action cannot be undone, all data will be lost. Are you sure you want to continue?",
  templatePublicateTitle: "Publish Template?",
  templatePublicateMessage: "Are you sure you want to continue and make this template public?",
  projectLayoutResetTitle: "Reset Project Layout?",
  projectLayoutResetMessage:
    "This action cannot be undone, all unsaved data will be lost. Are you sure you want to continue?",
  projectLayoutGoBackTitle: "Go Back to Project Page?",
  projectLayoutGoBackMessage:
    "This action cannot be undone, all unsaved data will be lost. Are you sure you want to continue?",
  projectDelete: "Delete Project",
  projectDeleteMessage: "Project will be deleted and all the data will be lost. Are you sure you want to continue?",
  projectReset: "Reset Project",
  projectResetMessage: "All unsaved changes will be lost. Are you sure you want to continue?",
  budgetAllocationError:
    "Sample for KPI/Channel combination not found. Assign budget to channel in Input tab and generate to get results",
  budgetAllocationErrorTitle: "Sample Not Found",
  outdatedOutputTitle: "Outdated Output",
  outdatedOutputMessage:
    "Some data in the Project has changed and the Output may be outdated. The Output can be regenerated on the Input edit page. ",
  bgDeleteTitle: "Delete the Business Goal",
  bgDeleteMessage: "Are you sure you want to delete this Business Goal?",
  planDeleteTitle: "Delete the Plan",
  planDeleteMessage: "Are you sure you want to delete this Plan?",
  scenarioCardDeleteTitle: "Delete the Scenario",
  scenarioCardDeleteMessage: "Are you sure you want to delete this Scenario?",
  leaveChangedProjectAddPlan: "Add New Plan",
  leaveChangedProject: "Edit plan",
  cleanCitiesZipsTitle: "Reset cities and zips list",
  cleanCitiesZipsText:
    "This action will clean all previously saved cities and zips. Are you sure you want to continue?",
  leaveChangedProjectMessage: "Project changes will be saved. Are you sure you want to continue?",
  selectTemplate: (name: string) => `Create output with template: ${name} ?`,
  selectTemplateHeader: "Select layout",
  deleteDashboardTitle: "Delete dashboard",
  deleteDashboardMessage: "Delete dashboard",
};
